import React from "react";

const Sidebar = ({ children, openedSidebar, setSidebar }) => (
    <aside
        aria-hidden={!openedSidebar}
        className={openedSidebar ? "visible" : "invisible"}
    >
        <div
            role="button"
            aria-label="Close Sidebar"
            aria-hidden
            onClick={() => setSidebar((prevState) => !prevState)}
            onKeyDown={() => setSidebar((prevState) => !prevState)}
            className={openedSidebar ? "w-full h-full fixed z-40 left-0 top-0 bg-black bg-opacity-70" : undefined}
        />
        <div className={` mobile-sidebar flex flex-col bg-white w-[21.875rem] overflow-y-auto shadow-[0_50px_0_0_rgb(255,255,255)] z-50 fixed bottom-0 transition-all duration-500 ease-in-out left-0 top-0 ${openedSidebar ? "translate-x-[0]" : "-translate-x-full"}`}>
            {children}
        </div>
    </aside>
);

export default Sidebar;
